<script lang="ts">
import { defineComponent, PropType } from 'vue'

import {
  CricketIncidentId,
  IllegalBallAttributesId,
} from '@collector/sportsapi-client-legacy'
import { ToggleButtonGroupOption } from '@mobile/components/ToggleButton/ToggleButtonGroup.vue'
import { PopupContext } from '@mobile/views/Relation/Shared/Popup/builder/types'

import SelectNumberOfPopup from '../SelectNumberOf/SelectNumberOfPopup.vue'

export default defineComponent({
  components: { SelectNumberOfPopup },
  props: {
    context: {
      type: Object as PropType<PopupContext | null>,
      required: false,
    },
  },
  setup() {
    const incidentId: CricketIncidentId.IllegalBall =
      CricketIncidentId.IllegalBall
    const coreAttributeId = IllegalBallAttributesId.NoBall
    const options: ToggleButtonGroupOption[] = [
      {
        name: '0',
        value: IllegalBallAttributesId.Zero,
      },
      {
        name: '1',
        value: IllegalBallAttributesId.One,
      },
      {
        name: '2',
        value: IllegalBallAttributesId.Two,
      },
      {
        name: '3',
        value: IllegalBallAttributesId.Three,
      },
      {
        name: '4',
        value: IllegalBallAttributesId.Four,
      },
      {
        name: '5',
        value: IllegalBallAttributesId.Five,
      },
      {
        name: '6',
        value: IllegalBallAttributesId.Six,
      },
      {
        name: '7',
        value: IllegalBallAttributesId.Seven,
      },
      {
        name: '8',
        value: IllegalBallAttributesId.Eight,
      },
      {
        name: '9',
        value: IllegalBallAttributesId.Nine,
      },
    ]

    return {
      options,
      incidentId,
      coreAttributeId,
    }
  },
})
</script>

<template>
  <div class="h-full w-full">
    <SelectNumberOfPopup
      v-bind="{ options, context, coreAttributeId, incidentId }"
      :title="'Select number of No ball Runs'"
    />
  </div>
</template>
